import { cloneElement, useEffect, useRef, useState } from 'react';

import Backdrop from '@mui/material/Backdrop';
import Collapse from '@mui/material/Collapse';
import Popover from '@mui/material/Popover';
import useMediaQuery from '@mui/material/useMediaQuery';

const containerCss = ({ constants }) => ({
  position: 'absolute',
  top: constants.APPBAR_HEIGHT,
  maxHeight: `calc(100dvh - ${constants.APPBAR_HEIGHT}px)`,
  left: 0,
  right: 0,
  overflow: 'auto',
  zIndex: 2,
});

const backdropCss = {
  zIndex: -1,
  background: 'linear-gradient(to bottom, transparent 56px, rgba(0,0,0,0.5) 56px)',
};

export default function PopoverResponsive({
  breakpoint = 'sm',
  button,
  CollapseProps,
  component: Component,
  componentProps,
  PopoverProps,
}) {
  const [open, setOpen] = useState(false);
  const anchorEl = useRef(null);

  const isSmall = useMediaQuery(({ breakpoints }) => breakpoints.down(breakpoint));
  const passedProps = { isSmall, open, setOpen };

  useEffect(() => {
    if (!(isSmall && open)) return;

    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prevOverflow;
    };
  }, [open, isSmall]);

  return (
    <>
      {renderButton()}
      {renderWrapper()}
    </>
  );

  function renderButton() {
    const buttonProps = { ref: anchorEl };
    if (typeof button === 'function') return button({ ...buttonProps, ...passedProps });
    return cloneElement(button, { ...buttonProps, onClick: () => setOpen(!open) });
  }

  function renderWrapper() {
    const content = <Component {...componentProps} {...passedProps} />;

    if (isSmall)
      return (
        <>
          <Collapse css={containerCss} in={open} {...CollapseProps}>
            {content}
          </Collapse>
          <Backdrop css={backdropCss} onClick={() => setOpen(false)} open={open} />
        </>
      );
    return (
      <Popover
        anchorEl={anchorEl.current}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        onClose={() => setOpen(false)}
        open={open}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        {...PopoverProps}
        slotProps={{
          backdrop: { invisible: false },
          ...PopoverProps?.slotProps,
        }}
      >
        {content}
      </Popover>
    );
  }
}
